import { render, staticRenderFns } from "./showimg.vue?vue&type=template&id=c3cb3aa2&"
import script from "./showimg.vue?vue&type=script&lang=ts&"
export * from "./showimg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "showimg.vue"
export default component.exports